import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IDic, IPublicSettings } from '@core/interfaces/store-data';

export interface IConnection {
	connection_id: number;
	connection_name?: string;
	isBG?: boolean;
	is_checked?: boolean | string;
	module_type: string;
	tool: string;
	toolLongName?: string;
}

export interface CommonState {
	loading: boolean;
	location: string; // lineage || discovery || compare
	dic: IDic;
	public_settings: IPublicSettings;
	isScanning: boolean;
	allConnections: Array<object>;
	loggedInUrl?: string;
	connectionsDisabled: boolean;
	legendMapDisplay: boolean;
}

export const selectCommonState = createFeatureSelector<CommonState>('common');
export const getLocation = createSelector(selectCommonState, state => state.location);
export const getDic = createSelector(selectCommonState, state => state.dic);
export const getPublicSettings = createSelector(selectCommonState, state => state.public_settings);
export const getIsScanning = createSelector(selectCommonState, state => state.isScanning);
export const getAllConnections = createSelector(selectCommonState, state => state.allConnections);
export const selectLoading = createSelector(selectCommonState, state => state.loading);
export const selectConnectionsDisabled = createSelector(selectCommonState, state => state.connectionsDisabled);
export const selectDisplayMapLegend = createSelector(selectCommonState, state => state.legendMapDisplay);

export const selectShowScriptEditorToolByType = (connectionMetaData: string) => createSelector(getAllConnections, (state) => {
	try {
		const decodedConnectionMetadata = JSON.parse(decodeURIComponent(atob(connectionMetaData)));
		const connection = state.find(connection => connection['NAME'] === decodedConnectionMetadata['connName']);
		const isETLWithFileType = connection["MODULE_TYPE"] === "ETL" && connection["MODULE_NAME"] === "FILE";
		const isDB = connection["MODULE_TYPE"] === "DB";

		if(connection && (isETLWithFileType || isDB)) {
			return true;
		}
		else {
			return false;
		}
	} catch (error) {
		console.error('Error parsing connection meta data', error);
		return false;
	}
});

// Recent Activities
export interface IRecentActivitiesInitialState {
	items: Array<any>;
	isOpen: boolean;
}

export const selectRecentActivitiesState = createFeatureSelector<IRecentActivitiesInitialState>('recentActivities');
export const selectRecentActivities = createSelector(selectRecentActivitiesState, state => state.items);
export const selectRecentActivitiesIsOpen = createSelector(selectRecentActivitiesState, state => state.isOpen);
